// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Anchor_anchor_2kQW5","isActive":"Anchor_isActive_1r3Yx","anchorList":"Anchor_anchorList_2c0Co"};